import React from 'react';
import { useTranslation } from 'react-i18next';
import { Paper, Typography } from '@mui/material';
import useStyles from './styles';
export default function MonthlySummary() {
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(Paper, null, /*#__PURE__*/React.createElement("div", {
    className: classes.summaryWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.summaryBlock, " ").concat(classes.monthTitle)
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, "December"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    color: "light"
  }, t('general.today'))), /*#__PURE__*/React.createElement("div", {
    className: classes.summaryBlock
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    color: "light"
  }, t('resident_account.starting_balance')), /*#__PURE__*/React.createElement(Typography, {
    variant: "h3"
  }, "$5.00")), /*#__PURE__*/React.createElement("div", {
    className: classes.summaryBlock
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    color: "light"
  }, t('resident_account.month_charges', {
    month: 'December'
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "h3",
    color: "dark"
  }, "+ $109.98")), /*#__PURE__*/React.createElement("div", {
    className: classes.summaryBlock
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    color: "light"
  }, t('resident_account.payments')), /*#__PURE__*/React.createElement(Typography, {
    variant: "h3",
    color: "success"
  }, "- $47.68")), /*#__PURE__*/React.createElement("div", {
    className: classes.summaryBlock
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    color: "light"
  }, t('resident_account.current_balance')), /*#__PURE__*/React.createElement(Typography, {
    variant: "h3"
  }, "$67.30"))));
}